import React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getBrackets } from '../../utilities/js/callouts/CalloutFactory';
import "./BracketList.css";
import BracketListItem from "./BracketListItem";
import LoadingDisplay from "./LoadingDisplay";

const BracketList = (props) => {    
    const emptyMessage = props.emptyMessage ? props.emptyMessage : 'No brackets were found'
    const options = getBracketCalloutOptions();

    let brackets = [];
    const bracketResponse = useQuery({
        queryKey: ['brackets', options], 
        queryFn: () => getBrackets(options), 
        staleTime: 1000*30 //Bracket feed can change every 30 seconds.  Prevents rapid reload on page switch
    })

    if(bracketResponse.data){
        brackets = bracketResponse.data.sort((a,b) => {
            return a.updated_date >= b.updated_date ? -1 : 1;
        });
    }

    if(bracketResponse.error){
        console.log(bracketResponse.error);
    }

    function getBracketCalloutOptions(){
        let calloutOptions = {};
        if(props.username){
            calloutOptions['username'] = props.username;
        }
        if(props.createdBy){
            calloutOptions['created_by'] = props.createdBy;
        }
        if(props.sortBy){
            calloutOptions['sortBy'] = props.sortBy;
        }
        if(props.offset){
            calloutOptions['offset'] = parseInt(props.offset);
        }
        if(props.permission){
            calloutOptions['permission'] = props.permission;//edit, view
        }
        if(props.limit){
            calloutOptions['limit'] = parseInt(props.limit);
        }
        if(props.feedId){
            calloutOptions['feedId'] = props.feedId;
        }
        return calloutOptions;
    }

    function getBracketsList(){
        let listOfBracketsToView = [];
        if(brackets.length > 0){

            listOfBracketsToView = brackets.map(bracket => {
                return (<BracketListItem key={bracket._id} bracket={bracket} variant={props.variant}></BracketListItem>)
            });
            
            return (<div key="container" className="bracket-list-container">{listOfBracketsToView}</div>);

        }else if(bracketResponse.isLoading){
            return (<LoadingDisplay isLoading={bracketResponse.isLoading}></LoadingDisplay>)
        }else{
            return (<div className="empty-bracket-list">{emptyMessage}</div>);
        }
    }

    return (<>
        {getBracketsList()}
    </>)

}




// class BracketList extends React.Component {

//     constructor(props) {
//         super(props);
//         this.state = {
//             brackets: [],
//             emptyMessage: this.props.emptyMessage ? this.props.emptyMessage : 'No brackets were found'
//         };

//         this.getBracketCalloutOptions = this.getBracketCalloutOptions.bind(this);
//     }


//     componentDidMount() {

//         let options = this.getBracketCalloutOptions();

//         getBrackets(options).then(response => {
//             if(response.length === 0 && this.props.onEmpty){
//                 this.props.onEmpty();
//             }else{
//                 let brackets = response.sort((a,b) => {
//                     return a.updated_date >= b.updated_date ? -1 : 1;
//                 });
                
//                 this.setState({ brackets: brackets });
//             }
//         }).catch(error => {
//             console.log(error);
//         })
//     }

//     getBracketCalloutOptions(){
//         let calloutOptions = {};
//         if(this.props.username){
//             calloutOptions['username'] = this.props.username;
//         }
//         if(this.props.createdBy){
//             calloutOptions['created_by'] = this.props.createdBy;
//         }
//         if(this.props.sortBy){
//             calloutOptions['sortBy'] = this.props.sortBy;
//         }
//         if(this.props.offset){
//             calloutOptions['offset'] = parseInt(this.props.offset);
//         }
//         if(this.props.permission){
//             calloutOptions['permission'] = this.props.permission;//edit, view
//         }
//         if(this.props.limit){
//             calloutOptions['limit'] = parseInt(this.props.limit);
//         }
//         if(this.props.feedId){
//             calloutOptions['feedId'] = this.props.feedId;
//         }
//         return calloutOptions;
//     }

//     getBracketsList(){
//         let listOfBracketsToView = [];
//         if(this.state.brackets.length > 0){

//             listOfBracketsToView = this.state.brackets.map(bracket => {
//                 return (<BracketListItem bracket={bracket} variant={this.props.variant}></BracketListItem>)
//             });
            
//             return (<div key="container" className="bracket-list-container">{listOfBracketsToView}</div>);

//         }else{
//             return (<div className="empty-bracket-list">{this.state.emptyMessage}</div>);
//         }
//     }


//     render() {
        
//         return (<>
//             {this.getBracketsList()}
//         </>)
//     }
// }

export default BracketList;
